"use client";

import React, { useEffect, useState } from "react";
import styles from "../UI/UI.module.css";
import { FontIcon } from "@/app/_components";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {RedeemRecordInfo} from "@/Core/Redeem/redeemEntity";
import {DriveUtil} from "@/Master/DriveUtil";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";

/**
 * 函数组件版 RedeemFailDialog 的 Props
 */
interface RedeemRecordSuccessfulProps extends SDialogProps {
    /** 额外参数 */
    // 可根据需要添加其他 Props，例如：errorMessage
    recordInfo:RedeemRecordInfo,
}

/**
 * 函数组件版 RedeemFailDialog
 */
export const RedeemRecordSuccessfulDialogFC: React.FC<RedeemRecordSuccessfulProps> = (props) => {
    const {fcKey, onClose, recordInfo} = props;
    const { closeDialog } = useDialogMethods(fcKey);
    // ========== 模拟生命周期（类似 class 的 initData / onInit / onEnter） ==========
    // 用一个内部 state 控制对话框是否还可见
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        return () => {
        };
    }, [props]);

    // ========== 按钮点击逻辑 ==========

    // ========== 渲染 UI ==========
    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title="Redemption Successful"
            buttons={[]}
            onClose={onClose}
        >
            <div className={styles.dialogContent}>
                <p>
                    Congratulations! The redemption amount of {DriveUtil.ToDollarString(recordInfo.dollar)} has been credited to
                    your {RedeemUtil.getChannelName(recordInfo.channelType)} account: {recordInfo.account} and a processing fee
                    of {DriveUtil.ToDollarString(recordInfo.fee)} has been charged.
                </p>
            </div>
        </SDialogFC>
    );
};
